import { Component, OnInit } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/auth/services/auth.service";
import { PropertyService } from "src/app/services/property/property.service";
import { environment } from "src/environments/environment";
import { locationRead, roleRead, tokenRead } from "../../../app.constants";
import { clientRead, deviceRead, userRead } from "./../../../app.constants";
import { Languages } from "./../../../models/properties/languages.model";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from "@angular/material/paginator";
import { RouterModule } from '@angular/router';
import { QuillModule } from "ngx-quill";
import { SharedModule } from "src/app/shared/shared.module";

@Component({
  standalone: true,
  imports: [CommonModule, SharedModule, MatDialogModule, MatMenuModule, MatPaginatorModule, TranslateModule, QuillModule, RouterModule],
  selector: "lns-topnav",
  templateUrl: "./topnav.component.html",
  styleUrls: ["./topnav.component.scss"],
})
export class TopnavComponent implements OnInit {
  loginPage = true;
  clientCanRead = clientRead;
  deviceCanRead = deviceRead;
  tokenCanRead = tokenRead;
  roleCanRead = roleRead;
  userCanRead = userRead;
  locationCanRead = locationRead;
  username: string;
  childrenMessageActive = false;
  childrenAuditLogsActive = false;
  languages: Languages;
  environment = environment;

  constructor(
    public authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private adapter: DateAdapter<any>,
    private propertyService: PropertyService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.childrenMessageActive = router.url.startsWith("/messages");
        this.childrenAuditLogsActive = router.url.startsWith("/audit-logs");
      }
    });
  }

  ngOnInit() {
    const currentLang = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";

    this.translate.use(currentLang);
    this.adapter.setLocale(currentLang);
    this.username = this.authService.getCurrentUserEmail();
    this.getLanguages();
  }

  switchLanguage(language: string) {
    const lang = language.toLowerCase();
    this.translate.use(lang);
    localStorage.setItem("language", lang);
    this.adapter.setLocale(lang);
  }

  logout() {
    this.authService.logout();
  }

  showNavLink(privilege?: string) {
    const isLogged = this.authService.isAuthenticatedOrRefresTokenNotExpired();
    if (!privilege) {
      return isLogged;
    }
    return isLogged && this.authService.hasPrivilege(privilege);
  }

  getLanguages() {
    this.propertyService.languages().subscribe((response) => {
      this.languages = response.body;
    });
  }
}
